<template>
  <div class="py-sm-6 px-sm-7 mb-15">
    <trading-section-component></trading-section-component>
  </div>
</template>
<script>
export default {
  name: "TradingSection",
  components: {
    TradingSectionComponent: () =>
      import("@/components/TradingSection/TradingSection.vue"),
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
